import { z } from 'zod';

export const subscriptionUpdatedNotificationSchema = z.object({
    type: z.literal('subscription/updated'),
    payload: z.object({
        practiceId: z.uuid(),
    }),
});

export const trialSubscriptionStartedNotificationSchema = z.object({
    type: z.literal('subscription/trial-started'),
    payload: z.object({
        subscriptionId: z.string(),
    }),
});
